/**
 * Muscle Grenade Remaster — client enhancements
 */
(function () {
  'use strict';

  /* Hide sold-out products in featured collection sections */
  document.querySelectorAll('.section-featured-collection, .collection').forEach(function (section) {
    if (section.dataset.mgHideSoldout === 'true') {
      section.classList.add('mg-hide-soldout');
    }
  });

  /* Coach sin foto rompe la grilla de la home */
  document.querySelectorAll('.section-featured-collection .grid__item').forEach(function (item) {
    if (item.querySelector('a[href*="/products/coach-grenade-mensual"]')) {
      item.style.display = 'none';
    }
  });

  /* Menú: TUDCA ya no es pre-venta */
  document.querySelectorAll('a').forEach(function (a) {
    var t = (a.textContent || '').trim();
    if (/tudca/i.test(t) && /pre-?venta/i.test(t)) {
      a.textContent = 'TUDCA Lithinin PRO';
    }
  });

  /* Dynamic weekly offer deadline (próximo domingo) */
  function weekendDeadlineLabel() {
    var now = new Date();
    var day = now.getDay();
    var daysToSun = day === 0 ? 0 : 7 - day;
    if (daysToSun === 0) return 'hoy domingo';
    var sun = new Date(now);
    sun.setDate(sun.getDate() + daysToSun);
    var dd = String(sun.getDate()).padStart(2, '0');
    var mm = String(sun.getMonth() + 1).padStart(2, '0');
    return 'el domingo ' + dd + '/' + mm;
  }

  function updateWeekendDeadlines() {
    var label = weekendDeadlineLabel();
    document.querySelectorAll('[data-mg-weekend-deadline]').forEach(function (el) {
      var template = el.getAttribute('data-mg-weekend-deadline') || 'Válido hasta {{date}}';
      el.textContent = template.replace('{{date}}', label);
    });
  }

  updateWeekendDeadlines();
})();